// Globals
import React from 'react';

// Components
import { StyledWrapper } from './ProductsTableStyles';
import { Table } from '@/ui';

// Models
import { IProductSync } from '@/models/akeneoSync.model';

// Helpers
import { productsTableColumns } from '../../utils/tableColumns';

type TProductTable = {
  productsSync: IProductSync[] | null;
  isLoading: boolean;
};

const ProductsTable = ({ productsSync, isLoading }: TProductTable) => {
  return (
    <StyledWrapper>
      <Table
        columns={productsTableColumns}
        rowKey={'id'}
        dataSource={productsSync ?? []}
        loading={isLoading}
        pagination={false}
        virtual
        rowHoverable
      />
    </StyledWrapper>
  );
};

export default ProductsTable;
